import { useTranslation } from "react-i18next";
import { LifeBuoy, Mail } from "lucide-react";
import { LegalLinks } from "../features/legal/LegalLinks";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { NeuCard } from "../components/neu/Neu";
import { SUPPORT_EMAIL, supportMailto } from "../config/support";

// صفحة دعم عامة (Support URL المطلوبة من آبل 1.5 وGoogle Play) — تعمل بدون تسجيل دخول.
export default function SupportPage() {
  const { t } = useTranslation();
  const rows = ["support.rowGeneral", "support.rowPrivacy", "support.rowDeletion", "support.rowSla"];

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-8 sm:px-8">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6 flex justify-end gap-2">
          <LangToggle />
          <ThemeToggle />
        </div>
        <NeuCard className="animate-rise-in p-7 sm:p-9" data-testid="support-page">
          <div className="flex items-center gap-3">
            <LifeBuoy className="h-6 w-6 text-primary" />
            <h1 className="text-3xl font-black tracking-tight">{t("support.pageTitle")}</h1>
          </div>
          <p className="mt-4 text-sm leading-7 text-muted-foreground">{t("support.pageIntro")}</p>
          <a
            href={supportMailto()}
            className="neu-in mt-6 flex items-center justify-center gap-2 rounded-2xl px-4 py-4 text-base font-black text-primary"
            data-testid="support-page-email"
          >
            <Mail className="h-5 w-5" />
            {SUPPORT_EMAIL}
          </a>
          <ul className="mt-6 grid gap-2 text-sm leading-7 text-muted-foreground">
            {rows.map((key) => (
              <li key={key}>• {t(key)}</li>
            ))}
          </ul>
          <div className="mt-8">
            <LegalLinks withLogin />
          </div>
        </NeuCard>
      </div>
    </div>
  );
}
